module.exports = __webpack_public_path__ + "media/images/flags/tf-1639d9248418223a4367c4aebe2c639e.svg";